// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reject-terms-he {
  font-size: 19px;
  font-weight: 500;
  color: #000;
}
.reject-terms-sub {
  font-size: 16px;
  color: #0a0f0d;
  font-weight: 500;
}
.reject-terms-text {
  font-size: 14px;
  font-weight: 400;
  color: #5b5e5d;
}
.reject-terms-reason-he {
  margin-top: 10px;
  font-size: 16px;
  font-weight: 400;
  color: #0a0f0d;
}
.reject-reason-select {
  width: 500px;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
}
.reject-reason-select
  .ant-select-outlined:not(.ant-select-customize-input)
  .ant-select-selector {
  border: none !important;
  background: #f5f5f5;
  height: 50px;
}
.reject-reason-select .ant-select-single {
  font-size: 14px;
  height: 40px;
  margin-bottom: 10px;
}
.reject-reason-select .ant-select-single {
  font-size: 14px;
  height: 40px;
  margin-bottom: 10px;
}
.reason-txt-area {
  background-color: #f5f5f5 !important;
  border: none;
}
.reason-txt-area:hover {
  background-color: #f5f5f5 !important;
  border: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/modal/reject-terms/RejectTerms.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;;EAGE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,YAAY;AACd;AACA;EACE,oCAAoC;EACpC,YAAY;AACd","sourcesContent":[".reject-terms-he {\n  font-size: 19px;\n  font-weight: 500;\n  color: #000;\n}\n.reject-terms-sub {\n  font-size: 16px;\n  color: #0a0f0d;\n  font-weight: 500;\n}\n.reject-terms-text {\n  font-size: 14px;\n  font-weight: 400;\n  color: #5b5e5d;\n}\n.reject-terms-reason-he {\n  margin-top: 10px;\n  font-size: 16px;\n  font-weight: 400;\n  color: #0a0f0d;\n}\n.reject-reason-select {\n  width: 500px;\n  background-color: #f5f5f5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.reject-reason-select\n  .ant-select-outlined:not(.ant-select-customize-input)\n  .ant-select-selector {\n  border: none !important;\n  background: #f5f5f5;\n  height: 50px;\n}\n.reject-reason-select .ant-select-single {\n  font-size: 14px;\n  height: 40px;\n  margin-bottom: 10px;\n}\n.reject-reason-select .ant-select-single {\n  font-size: 14px;\n  height: 40px;\n  margin-bottom: 10px;\n}\n.reason-txt-area {\n  background-color: #f5f5f5 !important;\n  border: none;\n}\n.reason-txt-area:hover {\n  background-color: #f5f5f5 !important;\n  border: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
